{
  "engagement.title": "أخبار الشركة",
  "engagement.subtitle": "الأخبار والسياسات والاستبيانات والمناسبات في 404 Creative.",
  "engagement.tabs.label": "أقسام أخبار الشركة",
  "engagement.tabs.news": "الأخبار",
  "engagement.tabs.policies": "السياسات",
  "engagement.tabs.surveys": "الاستبيانات",
  "engagement.tabs.celebrations": "المناسبات",
  "engagement.language.readEnglish": "Read in English",
  "engagement.language.readArabic": "اقرأ بالعربي",
  "engagement.language.back": "رجوع للعربي",
  "engagement.news.pinned": "مثبت",
  "engagement.news.unread": "جديد",
  "engagement.news.yourDepartment": "لقسمك",
  "engagement.news.readMore": "اقرأ المزيد",
  "engagement.news.showLess": "اعرض أقل",
  "engagement.news.until": "لحد {date}",
  "engagement.news.loadError": "معرفناش نحمّل الإعلانات.",
  "engagement.news.emptyTitle": "مفيش أخبار لسه",
  "engagement.news.emptyBody": "لما الموارد البشرية تنشر إعلان، هتلاقيه هنا.",
  "engagement.policies.loadError": "معرفناش نحمّل السياسات.",
  "engagement.policies.emptyTitle": "مفيش سياسات منشورة لسه",
  "engagement.policies.emptyBody": "سياسات الشركة هتظهر هنا أول ما الموارد البشرية تنشرها.",
  "engagement.policies.waiting": "{count, plural, zero {مفيش سياسات مستنياك} one {فيه سياسة مستنياك} two {فيه سياستين مستنيينك} few {فيه # سياسات مستنياك} many {فيه # سياسة مستنياك} other {فيه # سياسة مستنياك}}",
  "engagement.policies.waitingBody": "افتح كل واحدة واقراها، وبعدين أكّد بـ «قرأت وفهمت».",
  "engagement.policies.revisionOn": "الإصدار {number} · {date}",
  "engagement.policies.forReading": "للاطلاع",
  "engagement.policies.toAcknowledge": "محتاجة إقرار",
  "engagement.policies.acknowledgedShort": "تم الإقرار {date}",
  "engagement.policies.acknowledgedOn": "أقريت بالاطلاع على الإصدار ده يوم {date}.",
  "engagement.policies.revisionNote": "لما سياسة تتغير، الموارد البشرية بتنشر إصدار جديد ومطلوب من الكل يقراه ويقر بالاطلاع عليه تاني.",
  "engagement.policies.acknowledge": "قرأت وفهمت",
  "engagement.policies.acknowledging": "بنسجّل…",
  "engagement.policies.later": "بعدين",
  "engagement.policies.acknowledgeHint": "التأكيد بيسجّل إنك قريت الإصدار ده. لو السياسة اتغيرت، هنطلب منك تاني.",
  "engagement.policies.acknowledgedToast": "شكرًا، اتسجّل إقرارك بالاطلاع.",
  "engagement.surveys.loadError": "معرفناش نحمّل الاستبيانات.",
  "engagement.surveys.emptyTitle": "مفيش استبيانات مفتوحة",
  "engagement.surveys.emptyBody": "لما الموارد البشرية تفتح استبيان، تقدر تجاوب عليه من هنا.",
  "engagement.surveys.anonymous": "مجهول الهوية",
  "engagement.surveys.named": "مش مجهول الهوية",
  "engagement.surveys.questions": "{count, plural, zero {مفيش أسئلة} one {سؤال واحد} two {سؤالين} few {# أسئلة} many {# سؤال} other {# سؤال}}",
  "engagement.surveys.closesOn": "بيقفل {date}",
  "engagement.surveys.answered": "شكرًا، إنت جاوبت",
  "engagement.surveys.answer": "جاوب",
  "engagement.answer.backToSurveys": "كل الاستبيانات",
  "engagement.answer.loadError": "معرفناش نحمّل الاستبيان ده.",
  "engagement.answer.closedTitle": "الاستبيان ده اتقفل",
  "engagement.answer.closedBody": "مبقاش بيستقبل إجابات. شكرًا على اهتمامك.",
  "engagement.answer.anonymousTitle": "الاستبيان ده مجهول الهوية",
  "engagement.answer.anonymousBody": "محدش، ولا حتى الموارد البشرية، يقدر يعرف مين جاوب إيه. بنسجّل بس إنك شاركت عشان منسألكش مرتين. والنتايج مبتظهرش غير لما 3 أشخاص على الأقل يجاوبوا.",
  "engagement.answer.namedTitle": "الاستبيان ده مش مجهول الهوية",
  "engagement.answer.namedBody": "اسمك بيتسجّل مع إجاباتك، والموارد البشرية تقدر تشوف مين جاوب إيه.",
  "engagement.answer.formLabel": "إجاباتك",
  "engagement.answer.questionNumber": "سؤال {number}",
  "engagement.answer.optional": "اختياري",
  "engagement.answer.required": "من فضلك جاوب على السؤال ده.",
  "engagement.answer.scaleLow": "مش موافق خالص",
  "engagement.answer.scaleHigh": "موافق جدًا",
  "engagement.answer.npsLow": "مستبعد تمامًا",
  "engagement.answer.npsHigh": "أكيد جدًا",
  "engagement.answer.textHintAnonymous": "من فضلك متكتبش حاجة ممكن تعرّف بيك، زي اسمك أو موقف محدد.",
  "engagement.answer.textHint": "إجابتك بتوصل للموارد البشرية باسمك.",
  "engagement.answer.missing": "{count, plural, zero {كل الأسئلة المطلوبة متجاوب عليها.} one {فيه سؤال مطلوب لسه متجاوبش عليه.} two {فيه سؤالين مطلوبين لسه متجاوبش عليهم.} few {فيه # أسئلة مطلوبة لسه متجاوبش عليها.} many {فيه # سؤال مطلوب لسه متجاوبش عليه.} other {فيه # سؤال مطلوب لسه متجاوبش عليه.}}",
  "engagement.answer.send": "ابعت إجاباتي",
  "engagement.answer.sending": "بنبعت…",
  "engagement.answer.once": "تقدر تجاوب مرة واحدة بس، ومينفعش تغيّر الإجابات بعد ما تبعتها.",
  "engagement.answer.thanksTitle": "شكرًا إنك جاوبت",
  "engagement.answer.thanksBody": "إجاباتك وصلت، وهتساعدنا نخلّي 404 Creative مكان أحسن للشغل.",
  "engagement.answer.answeredTitle": "شكرًا، إنت جاوبت",
  "engagement.answer.answeredBody": "إنت جاوبت على الاستبيان ده قبل كده. كل واحد بيجاوب مرة واحدة.",
  "engagement.celebrations.upcoming": "المناسبات الجاية",
  "engagement.celebrations.upcomingDescription": "أعياد الميلاد وذكرى التعيين في الـ {days} يوم الجايين.",
  "engagement.celebrations.loadError": "معرفناش نحمّل المناسبات.",
  "engagement.celebrations.emptyTitle": "مفيش مناسبات قريبة",
  "engagement.celebrations.emptyBody": "أعياد الميلاد وذكرى التعيين بتظهر هنا لما تقرّب.",
  "engagement.celebrations.today": "النهارده",
  "engagement.celebrations.tomorrow": "بكرة",
  "engagement.celebrations.birthday": "عيد ميلاد",
  "engagement.celebrations.anniversary": "{years, plural, zero {أقل من سنة في 404 Creative} one {سنة في 404 Creative} two {سنتين في 404 Creative} few {# سنين في 404 Creative} many {# سنة في 404 Creative} other {# سنة في 404 Creative}}",
  "engagement.celebrations.preferenceTitle": "اللي بشاركه",
  "engagement.celebrations.preferenceDescription": "اختار الفريق يشوف إيه عنك هنا وفي الرئيسية.",
  "engagement.celebrations.preferenceError": "معرفناش نحمّل اختيارك.",
  "engagement.celebrations.shareBirthday": "شارك عيد ميلادي",
  "engagement.celebrations.shareBirthdayHint": "بيظهر اليوم والشهر بس، عمرك مبيظهرش أبدًا.",
  "engagement.celebrations.shareAnniversary": "شارك ذكرى تعييني",
  "engagement.celebrations.shareAnniversaryHint": "الفريق بيشوف بقالك كام سنة معانا.",
  "engagement.celebrations.preferenceSaved": "اتحفظ.",
  "engagement.errors.announcementNotFound": "الإعلان ده مبقاش متاح.",
  "engagement.errors.policyNotFound": "السياسة دي مبقتش متاحة.",
  "engagement.errors.surveyNotFound": "الاستبيان ده مبقاش مفتوح.",
  "engagement.errors.surveyState": "الخطوة دي متنفعش مع الاستبيان دلوقتي. حدّث الصفحة وجرّب تاني.",
  "engagement.errors.alreadyAnswered": "إنت جاوبت على الاستبيان ده قبل كده. شكرًا!",
  "engagement.hub.title": "التواصل والمشاركة",
  "engagement.hub.nav": "أقسام التواصل والمشاركة",
  "engagement.hub.announcements": "الإعلانات",
  "engagement.hub.policies": "السياسات",
  "engagement.hub.surveys": "الاستبيانات",
  "engagement.hub.noAccessTitle": "التواصل والمشاركة بيديرها مديرين الموارد البشرية",
  "engagement.hub.noAccessBody": "نشر الإعلانات والسياسات وإدارة الاستبيانات محتاجة صلاحية «إدارة الموارد البشرية». اطلبها من المالك لو محتاجها.",
  "engagement.form.titleAr": "العنوان بالعربي",
  "engagement.form.titleEn": "العنوان بالإنجليزي",
  "engagement.form.bodyAr": "النص بالعربي",
  "engagement.form.bodyEn": "النص بالإنجليزي",
  "engagement.form.errors.titleAr": "اكتب العنوان بالعربي.",
  "engagement.form.errors.titleEn": "اكتب العنوان بالإنجليزي.",
  "engagement.form.errors.bodyAr": "اكتب النص بالعربي.",
  "engagement.form.errors.bodyEn": "اكتب النص بالإنجليزي.",
  "engagement.form.audience": "موجّه لـ",
  "engagement.form.everyone": "الكل",
  "engagement.form.expiresOn": "يفضل ظاهر لحد",
  "engagement.form.expiresHint": "سيبه فاضي عشان يفضل ظاهر لحد ما تلغي نشره.",
  "engagement.form.pinned": "ثبّته فوق",
  "engagement.form.pinnedHint": "الإعلانات المثبتة بتفضل فوق الباقي.",
  "engagement.form.requiresAck": "اطلب إقرار بالاطلاع من الكل",
  "engagement.form.requiresAckHint": "الناس بتأكد «قرأت وفهمت»، وتقدر تشوف مين لسه مأكدش.",
  "engagement.form.saveDraft": "احفظ كمسودة",
  "engagement.form.save": "احفظ",
  "engagement.form.saving": "بنحفظ…",
  "engagement.manage.announcementsIntro": "اكتب الإعلانات بالعربي والإنجليزي، واختار هتوصل لمين، وانشرها لما تكون جاهزة.",
  "engagement.manage.announcementsCaption": "الإعلانات، ومعاها المسودات",
  "engagement.manage.newAnnouncement": "إعلان جديد",
  "engagement.manage.editAnnouncement": "تعديل الإعلان",
  "engagement.manage.announcementHint": "بيتحفظ كمسودة، والناس مش هتشوفه غير لما تنشره.",
  "engagement.manage.announcementSaved": "الإعلان اتحفظ.",
  "engagement.manage.noAnnouncementsTitle": "مفيش إعلانات لسه",
  "engagement.manage.noAnnouncementsBody": "اكتب أول إعلان عشان تشارك الأخبار مع الفريق.",
  "engagement.manage.columnTitle": "العنوان",
  "engagement.manage.columnStatus": "الحالة",
  "engagement.manage.columnPublished": "تاريخ النشر",
  "engagement.manage.columnReads": "قرأها",
  "engagement.manage.columnAcknowledged": "أقرّوا بالاطلاع",
  "engagement.manage.columnActions": "إجراءات",
  "engagement.manage.draft": "مسودة",
  "engagement.manage.published": "منشور",
  "engagement.manage.expired": "انتهى",
  "engagement.manage.oneDepartment": "قسم واحد",
  "engagement.manage.editNamed": "تعديل «{title}»",
  "engagement.manage.publish": "انشر",
  "engagement.manage.unpublish": "الغِ النشر",
  "engagement.manage.publishTitle": "تنشر «{title}»؟",
  "engagement.manage.publishBodyEveryone": "هيوصل للكل دلوقتي، وهيفضل متعلّم «جديد» لحد ما يقروه.",
  "engagement.manage.publishBodyDepartment": "هيوصل للقسم اللي اخترته دلوقتي، وهيفضل متعلّم «جديد» لحد ما يقروه.",
  "engagement.manage.unpublishTitle": "تلغي نشر «{title}»؟",
  "engagement.manage.unpublishBody": "هيرجع مسودة ويختفي من أخبار الكل. وهنفضل محتفظين بمين قراه.",
  "engagement.manage.publishedToast": "الإعلان اتنشر.",
  "engagement.manage.unpublishedToast": "الإعلان رجع مسودة.",
  "engagement.manage.policiesIntro": "خلّي سياسات الشركة في مكان واحد. كل إصدار بيتنشر بيطلب من الكل يقر بالاطلاع تاني.",
  "engagement.manage.policiesCaption": "سياسات الشركة، ومعاها المسودات",
  "engagement.manage.newPolicy": "سياسة جديدة",
  "engagement.manage.editPolicy": "تعديل السياسة",
  "engagement.manage.noPoliciesTitle": "مفيش سياسات لسه",
  "engagement.manage.noPoliciesBody": "ضيف أول سياسة، زي مواعيد الشغل أو الشغل من البيت.",
  "engagement.manage.revision": "الإصدار {number}",
  "engagement.manage.publishRevision": "انشر إصدار جديد",
  "engagement.manage.publishPolicyTitle": "تنشر الإصدار {number}؟",
  "engagement.manage.publishPolicyBody": "هنطلب من الكل يقرا السياسة دي ويقر بالاطلاع عليها تاني، حتى اللي أقرّوا بإصدار قديم.",
  "engagement.manage.publishPolicyBodyNoAck": "الكل هيشوف النص الجديد. السياسة دي مش محتاجة إقرار بالاطلاع.",
  "engagement.manage.policyPublishedToast": "الإصدار {number} اتنشر.",
  "engagement.manage.policySaved": "السياسة اتحفظت كمسودة.",
  "engagement.manage.policySavedPublished": "اتحفظت. انشر إصدار جديد عشان التعديل يوصل للناس.",
  "engagement.manage.policyEditNote": "الناس هتفضل شايفة الإصدار المنشور لحد ما تنشر التعديل ده كإصدار جديد.",
  "engagement.manage.trackingTitle": "الإقرارات بالاطلاع",
  "engagement.manage.trackingNamed": "مين أقرّ بالاطلاع على «{title}»",
  "engagement.manage.trackingRevision": "للإصدار {number}",
  "engagement.manage.trackingError": "معرفناش نحمّل مين أقرّ بالاطلاع.",
  "engagement.manage.trackingFilter": "اعرض",
  "engagement.manage.acknowledgedOf": "{done} من {total} أقرّوا بالاطلاع",
  "engagement.manage.notYet": "لسه",
  "engagement.manage.acknowledged": "أقرّوا",
  "engagement.manage.copyNames": "انسخ الأسماء",
  "engagement.manage.namesCopied": "{count, plural, zero {مفيش أسماء اتنسخت.} one {اتنسخ اسم واحد للتذكير.} two {اتنسخ اسمين للتذكير.} few {اتنسخ # أسماء للتذكير.} many {اتنسخ # اسم للتذكير.} other {اتنسخ # اسم للتذكير.}}",
  "engagement.manage.everyoneDone": "الكل أقرّ بالاطلاع على الإصدار ده.",
  "engagement.manage.nobodyYet": "محدش أقرّ بالاطلاع على الإصدار ده لسه.",
  "engagement.surveysAdmin.intro": "اعمل استبيانات نبض ومؤشر صافي ترويج الموظفين (eNPS)، وافتحها للفريق، واقرا النتايج من أول 3 إجابات.",
  "engagement.surveysAdmin.caption": "الاستبيانات",
  "engagement.surveysAdmin.new": "استبيان جديد",
  "engagement.surveysAdmin.emptyTitle": "مفيش استبيانات لسه",
  "engagement.surveysAdmin.emptyBody": "ابدأ باستبيان نبض قصير أو استبيان eNPS.",
  "engagement.surveysAdmin.responses": "الإجابات",
  "engagement.surveysAdmin.results": "النتايج",
  "engagement.surveysAdmin.resultsNamed": "نتايج «{title}»",
  "engagement.surveysAdmin.edit": "تعديل",
  "engagement.surveysAdmin.statusDraft": "مسودة",
  "engagement.surveysAdmin.statusOpen": "مفتوح",
  "engagement.surveysAdmin.statusClosed": "مقفول",
  "engagement.surveysAdmin.open": "افتح الاستبيان",
  "engagement.surveysAdmin.openTitle": "تفتح «{title}»؟",
  "engagement.surveysAdmin.openBody": "الكل يقدر يجاوب من دلوقتي. الأسئلة وكونه مجهول الهوية أو لأ مش هيتغيروا بعد ما يتفتح.",
  "engagement.surveysAdmin.openedToast": "الاستبيان اتفتح.",
  "engagement.surveysAdmin.close": "اقفل الاستبيان",
  "engagement.surveysAdmin.closeTitle": "تقفل «{title}»؟",
  "engagement.surveysAdmin.closeBody": "هيبطّل يستقبل إجابات. وتقدر تفتحه تاني للي اتأخروا.",
  "engagement.surveysAdmin.closedToast": "الاستبيان اتقفل.",
  "engagement.surveysAdmin.reopen": "افتحه تاني",
  "engagement.surveysAdmin.reopenTitle": "تفتح «{title}» تاني؟",
  "engagement.surveysAdmin.reopenBody": "اللي لسه مجاوبوش يقدروا يجاوبوا. والإجابات اللي اتبعتت هتفضل زي ما هي.",
  "engagement.surveysAdmin.reopenedToast": "الاستبيان اتفتح تاني.",
  "engagement.builder.newTitle": "استبيان جديد",
  "engagement.builder.editTitle": "تعديل الاستبيان",
  "engagement.builder.back": "كل الاستبيانات",
  "engagement.builder.settings": "الاستبيان",
  "engagement.builder.introAr": "المقدمة بالعربي",
  "engagement.builder.introEn": "المقدمة بالإنجليزي",
  "engagement.builder.kind": "النوع",
  "engagement.builder.kindPulse": "نبض",
  "engagement.builder.kindEnps": "مؤشر صافي ترويج الموظفين (eNPS)",
  "engagement.builder.kindCustom": "مخصص",
  "engagement.builder.anonymous": "مجهول الهوية",
  "engagement.builder.anonymousOnHint": "محدش، ولا الموارد البشرية، يقدر يعرف مين جاوب إيه. بيتثبّت أول ما الاستبيان يتفتح.",
  "engagement.builder.anonymousOffHint": "الإجابات بتتسجّل بأسماء أصحابها، وبنقول ده للناس قبل ما يجاوبوا. بيتثبّت أول ما الاستبيان يتفتح.",
  "engagement.builder.closesOn": "بيقفل يوم",
  "engagement.builder.closesOnHint": "اختياري. الإجابات بتتقبل لحد آخر اليوم ده.",
  "engagement.builder.questions": "الأسئلة",
  "engagement.builder.add": "ضيف سؤال:",
  "engagement.builder.questionScale": "مقياس من 1 لـ 5",
  "engagement.builder.questionNps": "eNPS من 0 لـ 10",
  "engagement.builder.questionChoice": "اختيار من متعدد",
  "engagement.builder.questionText": "إجابة مكتوبة",
  "engagement.builder.questionKind": "نوع السؤال {number}",
  "engagement.builder.promptAr": "السؤال بالعربي",
  "engagement.builder.promptEn": "السؤال بالإنجليزي",
  "engagement.builder.required": "إجباري",
  "engagement.builder.moveUp": "اطلع بالسؤال {number} لفوق",
  "engagement.builder.moveDown": "انزل بالسؤال {number} لتحت",
  "engagement.builder.removeQuestion": "امسح السؤال {number}",
  "engagement.builder.options": "الاختيارات",
  "engagement.builder.optionAr": "الاختيار {number} بالعربي",
  "engagement.builder.optionEn": "الاختيار {number} بالإنجليزي",
  "engagement.builder.optionArPlaceholder": "بالعربي",
  "engagement.builder.optionEnPlaceholder": "In English",
  "engagement.builder.removeOption": "امسح الاختيار {number}",
  "engagement.builder.addOption": "ضيف اختيار",
  "engagement.builder.errors.promptAr": "اكتب السؤال بالعربي.",
  "engagement.builder.errors.promptEn": "اكتب السؤال بالإنجليزي.",
  "engagement.builder.errors.options": "حط من 2 لـ 12 اختيار، كل واحد بالعربي والإنجليزي.",
  "engagement.builder.errors.noQuestions": "اسأل سؤال واحد على الأقل.",
  "engagement.builder.enpsStandardAr": "على مقياس من 0 لـ 10، قد إيه ممكن ترشّح 404 Creative كمكان للشغل لصاحب أو قريب؟",
  "engagement.builder.enpsStandardEn": "On a scale of 0 to 10, how likely are you to recommend 404 Creative as a place to work to a friend?",
  "engagement.builder.lockNote": "الأسئلة وإخفاء الهوية بيتثبّتوا أول ما الاستبيان يتفتح.",
  "engagement.builder.saved": "الاستبيان اتحفظ كمسودة.",
  "engagement.builder.fixedTitle": "الاستبيان ده مبقاش ينفع يتعدّل",
  "engagement.builder.fixedBody": "أول ما الاستبيان يتفتح، أسئلته وإخفاء الهوية بيتثبّتوا عشان كل الإجابات يكون ليها نفس المعنى.",
  "engagement.results.loadError": "معرفناش نحمّل النتايج.",
  "engagement.results.draft": "النتايج بتظهر لما الاستبيان يتفتح والناس تجاوب.",
  "engagement.results.hiddenTitle": "{count} من {total} إجابات مطلوبة عشان النتايج تظهر",
  "engagement.results.hiddenBody": "{count, plural, zero {النتايج هتظهر دلوقتي.} one {فاضل إجابة واحدة والنتايج تظهر. لحد كده مش بنعرض حاجة عشان محدش يتعرف من إجابته.} two {فاضل إجابتين والنتايج تظهر. لحد كده مش بنعرض حاجة عشان محدش يتعرف من إجابته.} few {فاضل # إجابات والنتايج تظهر. لحد كده مش بنعرض حاجة عشان محدش يتعرف من إجابته.} many {فاضل # إجابة والنتايج تظهر. لحد كده مش بنعرض حاجة عشان محدش يتعرف من إجابته.} other {فاضل # إجابة والنتايج تظهر. لحد كده مش بنعرض حاجة عشان محدش يتعرف من إجابته.}}",
  "engagement.results.responses": "الإجابات",
  "engagement.results.invited": "{count, plural, zero {مفيش مدعوين} one {من شخص واحد مدعو} two {من شخصين مدعوين} few {من # أشخاص مدعوين} many {من # شخص مدعو} other {من # شخص مدعو}}",
  "engagement.results.rate": "نسبة المشاركة",
  "engagement.results.enpsTitle": "مؤشر صافي ترويج الموظفين (eNPS)",
  "engagement.results.enpsHint": "نسبة المروّجين ناقص نسبة المنتقدين.",
  "engagement.results.enpsScale": "من −100 لـ +100",
  "engagement.results.promoters": "مروّجين",
  "engagement.results.passives": "محايدين",
  "engagement.results.detractors": "منتقدين",
  "engagement.results.promotersRange": "جاوبوا 9–10",
  "engagement.results.passivesRange": "جاوبوا 7–8",
  "engagement.results.detractorsRange": "جاوبوا 0–6",
  "engagement.results.questionTitle": "{number}. {title}",
  "engagement.results.answered": "{count, plural, zero {مفيش إجابات} one {إجابة واحدة} two {إجابتين} few {# إجابات} many {# إجابة} other {# إجابة}}",
  "engagement.results.meanOf": "{count, plural, zero {مفيش إجابات} one {إجابة واحدة} two {إجابتين} few {# إجابات} many {# إجابة} other {# إجابة}} · المتوسط {number} من {total}",
  "engagement.results.textCount": "{count, plural, zero {مفيش إجابات مكتوبة} one {إجابة مكتوبة واحدة، بالترتيب الأبجدي} two {إجابتين مكتوبين، بالترتيب الأبجدي} few {# إجابات مكتوبة، بالترتيب الأبجدي} many {# إجابة مكتوبة، بالترتيب الأبجدي} other {# إجابة مكتوبة، بالترتيب الأبجدي}}",
  "engagement.results.noTexts": "محدش كتب إجابة على السؤال ده.",
  "engagement.results.columnAnswer": "الإجابة",
  "engagement.results.columnCount": "العدد",
  "engagement.results.columnShare": "النسبة",
  "engagement.results.byDepartment": "الإجابات حسب القسم",
  "engagement.results.byDepartmentHint": "الأقسام اللي فيها أقل من 3 إجابات بتتجمّع مع بعض عشان محدش يتعرف.",
  "engagement.results.otherDepartments": "أقسام تانية",
  "engagement.results.noDepartments": "مفيش قسم عنده إجابات كفاية تظهر لوحدها.",
  "engagement.home.sectionLabel": "الناس",
  "engagement.home.waitingTitle": "مستنياك",
  "engagement.home.allDone": "مفيش حاجة مستنياك.",
  "engagement.home.loadError": "معرفناش نحمّل ده.",
  "engagement.home.decisions": "{count, plural, zero {طلبات محتاجة قرارك} one {طلب محتاج قرارك} two {طلبين محتاجين قرارك} few {طلبات محتاجة قرارك} many {طلب محتاج قرارك} other {طلب محتاج قرارك}}",
  "engagement.home.checklist": "{count, plural, zero {مهام في قائمة المتابعة} one {مهمة في قائمة المتابعة} two {مهمتين في قائمة المتابعة} few {مهام في قائمة المتابعة} many {مهمة في قائمة المتابعة} other {مهمة في قائمة المتابعة}}",
  "engagement.home.reviews": "{count, plural, zero {تقييمات محتاج تكتبها} one {تقييم محتاج تكتبه} two {تقييمين محتاج تكتبهم} few {تقييمات محتاج تكتبها} many {تقييم محتاج تكتبه} other {تقييم محتاج تكتبه}}",
  "engagement.home.interviews": "{count, plural, zero {مقابلات النهارده} one {مقابلة النهارده} two {مقابلتين النهارده} few {مقابلات النهارده} many {مقابلة النهارده} other {مقابلة النهارده}}",
  "engagement.home.policies": "{count, plural, zero {سياسات محتاجة إقرار} one {سياسة محتاجة إقرار} two {سياستين محتاجين إقرار} few {سياسات محتاجة إقرار} many {سياسة محتاجة إقرار} other {سياسة محتاجة إقرار}}",
  "engagement.home.surveys": "{count, plural, zero {استبيانات مستنية إجابتك} one {استبيان مستني إجابتك} two {استبيانين مستنيين إجابتك} few {استبيانات مستنية إجابتك} many {استبيان مستني إجابتك} other {استبيان مستني إجابتك}}",
  "engagement.home.announcements": "{count, plural, zero {إعلانات مقرتهاش} one {إعلان مقرتهوش} two {إعلانين مقرتهمش} few {إعلانات مقرتهاش} many {إعلان مقرتهوش} other {إعلان مقرتهوش}}",
  "engagement.home.outTitle": "مش موجودين النهارده",
  "engagement.home.outCount": "{count, plural, zero {محدش} one {شخص واحد} two {شخصين} few {# أشخاص} many {# شخص} other {# شخص}}",
  "engagement.home.nobodyOut": "الكل موجود النهارده.",
  "engagement.home.backAfter": "لحد {date}",
  "engagement.home.todayOnly": "النهارده بس",
  "engagement.home.celebrationsTitle": "مناسبات الأسبوع ده",
  "engagement.home.noCelebrations": "مفيش أعياد ميلاد ولا ذكرى تعيين الأسبوع ده.",
  "engagement.home.seeAll": "اعرض الكل"
}
